import { PermissionSetsResponse } from '../viewModels/AWSAccounts/PermissionSetsResponse';

export function getRequiredPermissionSets(permissionSets: PermissionSetsResponse): string[] {
    return permissionSets.Always || [];
}

export const getOtherPermissionSets = (permissionSets: PermissionSetsResponse): string[] => {
    return permissionSets.Other || [];
};

export function getPermissionSetsForCreation(permissionSets: PermissionSetsResponse): string[] {
    return permissionSets.Always || [];
}

export function getPermissionSetsForModification(permissionSets: PermissionSetsResponse): string[] {
    return [
        ...(permissionSets.Always || []),
        ...(permissionSets.ModificationOnly || []),
    ];
}

export function getAllAvailablePermissionSets(permissionSets: PermissionSetsResponse): string[] {
    return [
        ...(permissionSets.Always || []),
        ...(permissionSets.ModificationOnly || []),
        ...(permissionSets.Other || []),
    ];
}

export function isRequiredPermissionSet(permissionSet: string, permissionSets: PermissionSetsResponse): boolean {
    return (permissionSets.Always || []).includes(permissionSet);
}

export function getVisibilityForPermissionSet(
    permissionSet: string, 
    permissionSets: PermissionSetsResponse
): 'Always' | 'ModificationOnly' | 'Other' | null {
    if ((permissionSets.Always || []).includes(permissionSet)) return 'Always';
    if ((permissionSets.ModificationOnly || []).includes(permissionSet)) return 'ModificationOnly';
    if ((permissionSets.Other || []).includes(permissionSet)) return 'Other';
    return null;
}

export const ACCOUNT_TYPE_NAMES = {
    DISCONNECTED: 'Disconnected AWS',
    MANAGED: 'Managed AWS',
} as const;
